<footer class="footer is-fixed-bottom">
  <div class="content has-text-centered">
    <p>
      <strong>Scaborough Software Ventures LLC</strong> copyright 2017, all rights reserved.
    </p>
  </div>
</footer>
